module.exports = __webpack_public_path__ + "img/10.d62bcfd5.svg";